(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ri-shopfront-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ri-size-shop')) return;
  class RISizeShop extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.grid = this.querySelector('[data-ri-grid]');
      this.status = this.querySelector('[data-ri-status]');
      this.resultsTitle = this.querySelector('[data-ri-results-title]');
      this.more = this.querySelector('[data-ri-more]');
      this.resetButton = this.querySelector('[data-ri-reset]');
      this.featured = Array.from(this.grid.children, node => node.cloneNode(true));
      this.catalog = null;
      this.visibleCount = 12;
      this.generation = 0;
      this.abortEvents = new AbortController();
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-ri-size]');
        if (choice && this.contains(choice)) this.select(choice.dataset.riSize, true);
        if (event.target.closest('[data-ri-more]')) { this.visibleCount += 12; this.render(true); }
        if (event.target.closest('[data-ri-reset]')) this.reset(true);
      }, { signal: this.abortEvents.signal });
      this.readHash = () => {
        const match = location.hash.match(/^#shop-by-size=(XS|S|M|L|XL|2XL|3XL|OTHER|ALL)$/);
        if (match) { this.select(match[1], false); this.scrollIntoView({block:'start'}); }
        else if (this.selected) this.reset(false);
      };
      window.addEventListener('hashchange', this.readHash, { signal: this.abortEvents.signal });
      this.readHash();
    }
    disconnectedCallback() {
      this.abortEvents?.abort();
      this.fetchController?.abort();
      this.generation += 1;
      this.bound = false;
    }
    async loadCatalog() {
      if (this.catalog) return this.catalog;
      if (this.loading) return this.loading;
      const controller = new AbortController();
      this.fetchController = controller;
      const timeout = setTimeout(() => controller.abort(), 30000);
      this.loading = (async () => {
        let page = 1;
        const seen = new Set();
        const cards = new Map();
        while (page) {
          if (seen.has(page) || seen.size >= 100) throw new Error('Catalog pagination could not be completed.');
          seen.add(page);
          const url = new URL(this.dataset.riCatalogUrl, location.origin);
          url.searchParams.set('section_id', this.dataset.riSection);
          url.searchParams.set('filter.v.availability', '1');
          url.searchParams.set('sort_by', 'created-descending');
          url.searchParams.set('page', String(page));
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
          if (!response.ok) throw new Error('Catalog request failed.');
          const documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
          const pageRoot = documentPage.querySelector('[data-ri-catalog-page]');
          if (!pageRoot) throw new Error('Catalog response was incomplete.');
          for (const card of pageRoot.querySelectorAll('[data-ri-product-id]')) {
            if (card.dataset.riSizes) cards.set(card.dataset.riProductId, card);
          }
          const next = pageRoot.dataset.riNextPage;
          page = next ? Number(next) : 0;
          if (next && (!Number.isInteger(page) || page < 1)) throw new Error('Invalid catalog page.');
        }
        this.catalog = Array.from(cards.values());
        return this.catalog;
      })();
      try { return await this.loading; }
      finally { clearTimeout(timeout); this.loading = null; }
    }
    async select(size, updateHash) {
      this.selected = size;
      this.visibleCount = 12;
      const request = ++this.generation;
      if (updateHash) { const url = new URL(location.href); url.hash = 'shop-by-size=' + size; history.replaceState(null, '', url); }
      this.querySelectorAll('[data-ri-size]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.riSize === size)));
      this.resetButton.hidden = false;
      this.more.hidden = true;
      this.resultsTitle.textContent = size === 'ALL' ? 'All available pieces.' : size === 'OTHER' ? 'Other available sizes.' : size + ' — available pieces.';
      this.grid.replaceChildren();
      this.grid.setAttribute('aria-busy', 'true');
      this.status.textContent = 'Checking available pieces…';
      try { await this.loadCatalog(); if (request === this.generation && this.isConnected) this.render(false); }
      catch (error) { if (request === this.generation && this.isConnected) this.status.textContent = 'We could not load sizes. Tap your size to retry, or use Browse all available pieces below.'; }
      finally { if (request === this.generation) this.grid.removeAttribute('aria-busy'); }
    }
    render(focusNew) {
      if (!this.catalog) return;
      const matches = this.selected === 'ALL' ? this.catalog : this.catalog.filter(card => card.dataset.riSizes.includes('|' + this.selected + '|'));
      const before = this.grid.children.length;
      const nodes = matches.slice(0, this.visibleCount).map(node => {
        const clone = node.cloneNode(true);
        const variant = clone.querySelector('[data-ri-variant-size="' + this.selected + '"]');
        if (variant) clone.querySelector('.ri-card__link').setAttribute('href', variant.dataset.riVariantUrl);
        return clone;
      });
      this.grid.replaceChildren(...nodes);
      this.more.hidden = matches.length <= this.visibleCount;
      this.status.textContent = matches.length ? 'Showing ' + Math.min(matches.length, this.visibleCount) + ' of ' + matches.length + ' available pieces. Check measurements on each listing.' : 'No pieces in this size are available right now. Try another size or check back for new finds.';
      if (focusNew) this.grid.children[before]?.querySelector('a')?.focus();
    }
    reset(updateHash) {
      this.generation += 1;
      this.selected = null;
      this.grid.replaceChildren(...this.featured.map(node => node.cloneNode(true)));
      this.grid.removeAttribute('aria-busy');
      this.querySelectorAll('[data-ri-size]').forEach(button => button.setAttribute('aria-pressed', 'false'));
      this.more.hidden = true;
      this.resetButton.hidden = true;
      this.resultsTitle.textContent = 'Featured available pieces.';
      this.status.textContent = 'A few featured pieces. Choose a size to search the full available collection.';
      if (updateHash) { const url = new URL(location.href); url.hash = 'shop-by-size'; history.replaceState(null, '', url); }
    }
  }
  customElements.define('ri-size-shop', RISizeShop);
})();

  } catch(e) { console.error(e); }
})();
})();
